import moment from "moment"

import { MobileField, readPath } from "./config"

/** 1234567.5 -> "1 234 568" */
export function num(value: any): string {
  const n = Number(value || 0)
  if (!Number.isFinite(n)) return "0"
  const rounded = Math.abs(n) >= 100 ? Math.round(n) : Math.round(n * 100) / 100
  return rounded.toLocaleString("ru-RU")
}

/**
 * Katakcha qiymatini ko'rsatishga tayyorlaydi.
 *
 * Sana bo'sh bo'lsa chiziqcha qo'yiladi — telefonda "Invalid date"
 * yozuvi ko'rinib qolmasligi kerak.
 */
export function cellText(row: any, field: MobileField): string {
  const raw = readPath(row, field.path)

  switch (field.type) {
    case "date": {
      if (!raw) return "—"
      const m = moment(raw)
      return m.isValid() ? m.format("DD.MM.YYYY") : "—"
    }
    case "datetime": {
      if (!raw) return "—"
      const m = moment(raw)
      return m.isValid() ? m.format("DD.MM.YYYY HH:mm") : "—"
    }
    case "money":
      return `$${num(raw)}`
    case "number":
      return num(raw)
    case "status":
      return raw === 1 || raw === true ? "✓" : "—"
    /*
      Ro'yxat: bir yozuv bir nechta joyga tegishli bo'lganda.
      Masalan qoldiqlarda bitta tovar bir nechta omborda turadi va
      yuqori darajadagi "ombor" maydoni bo'sh bo'ladi — taqsimot esa
      ichkarida. Ilgari bunday katakcha shunchaki chiziqcha
      ko'rsatardi, ya'ni ma'lumot bor edi-yu, ko'rinmasdi.
    */
    case "list": {
      if (!Array.isArray(raw) || raw.length === 0) return "—"
      return raw
        .map((item: any) => {
          const name = item?.[field.listNameKey || "name"]
          const value = field.listValueKey ? item?.[field.listValueKey] : undefined
          if (!name) return null
          return value === undefined || value === null
            ? String(name)
            : `${name}: ${num(value)}`
        })
        .filter(Boolean)
        .join(", ")
    }
    default: {
      const text = raw === null || raw === undefined ? "" : String(raw).trim()
      return text.length > 0 ? text : "—"
    }
  }
}
